import React, { ReactNode, forwardRef } from 'react';
import { DropdownListContainer, Overlay } from '../../styled/DropdownMenu/wrappers';

interface IDropdownMenu {
  children: ReactNode;
  onClose: () => void;
}

const DropdownMenu = (
  { children, onClose }: IDropdownMenu,
  ref: React.ForwardedRef<HTMLDivElement>,
) => {
  return (
    <>
      <DropdownListContainer ref={ref}>{children}</DropdownListContainer>
      <Overlay onClick={onClose} />
    </>
  );
};

export default forwardRef(DropdownMenu);
